export default __webpack_public_path__ + "static/media/uploader-oneTouchUltraMini-1.b47008ff.png";